import React from "react";
import { sanitize } from "@/framework/utils/sanitize";
import Section from "@/components/ui/section";
import SectionHeading from "@/components/ui/carousel/section-heading";
import ProductGrid from "@/components/pages/product.js/product-grid";
import BannerCard from "@/components/ui/banner-card";
import Seo from "@/utils/seo";
import { categories } from "@/data/categories";
export default function CategoryPage({ categoryData }) {
  return (
    <>
      <Seo
        metaTitle={`${categoryData?.name} | Rose Bowl`}
        slug={`category/${categoryData?.slug}`}
      />
      <BannerCard
        banner={
          categoryData?.image?.data?.attributes?.url ??
          "/images/placeholder.svg"
        }
        title={categoryData?.name}
        variant="small"
      />
      <Section variant="flat" className="mb-8">
        <SectionHeading title={categoryData?.name} tag="Lifestyle" />
        <ProductGrid
          products={categoryData?.products?.data?.map((row) => sanitize(row))}
        />
      </Section>
    </>
  );
}

export async function getStaticProps({ params = {} } = {}) {
  let props = {};
  try {
    const data = categories.find((cat) => cat.slug === params.slug);
    props = {
      categoryData: data ?? [],
    };
  } catch (error) {
    console.log(error);
  }
  return {
    props: props,
    // revalidate: 10,
  };
}
export async function getStaticPaths() {
  let paths = [];
  try {
    paths = categories.map((category) => {
      return {
        params: {
          slug: category.slug,
        },
      };
    });
  } catch (error) {
    //console.log(error.networkError.result);
  }
  return {
    paths,
    fallback: false,
  };
}
